import { Injectable } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

export type dateUnits = 
|  'year'
|  'month'
|  'day'

@Injectable({ providedIn: 'root' })
export class DateService {

  constructor() { }


  /**
   * 
   * @param date Date object to format
   * @param separator Separate date member by {separator} (by default separator = '.')
   * @returns Return the date in DD{separator}MM{separator}YYYY
   */
  format(date: Date, separator: string = '.') {
    return date.toLocaleString().split(' ')[0].replaceAll('/', separator); 
  }

  /**
   * Format a ngbDateStruct to a Date object
   * @param ngbDate 
   * @returns 
   */
  ngbDateToDate(ngbDate: NgbDateStruct) {
    return new Date(`${ngbDate.year} ${ngbDate.month} ${ngbDate.day}`);
  }

  /**
   * Return the start date of the specified unit
   * @param date 
   * @param unit 
   * @returns 
   */
  startOf(date: Date, unit: dateUnits) {
    // On fait +1 sur les mois parce que janvier commence à 0
    switch(unit) {
      case 'year':
        return new Date(`${date.getFullYear()}`);
      case 'month':
        return new Date(`${date.getFullYear()} ${date.getMonth() + 1}`);
      case 'day':
        try {
          return new Date(`${date.getFullYear()} ${date.getMonth() + 1} ${date.getDate()}`)
        } catch(e) {
          console.log(date)
        }
    }
  }

  isSame(date1: Date, date2: Date, unit: dateUnits) {
    switch(unit) {
      case 'year':
        return this.isSameYear(date1, date2);
      case 'month':
        return this.isSameYear(date1, date2) && this.isSameMonth(date1, date2);
      case 'day':
        return this.isSameYear(date1, date2) && this.isSameMonth(date1, date2) && this.isSameDay(date1, date2);
    }
  }

  isSameYear(date1: Date, date2: Date) {
    return date1.getFullYear() === date2.getFullYear();
  }

  isSameMonth(date1: Date, date2: Date) {
    return date1.getMonth() === date2.getMonth();
  }

  isSameDay(date1: Date, date2: Date) {
    return date1.getDate() === date2.getDate();
  }
}
